import {FC, HTMLAttributes} from 'react'

export const NavigateLogoIcon: FC<{size?: number} & HTMLAttributes<SVGSVGElement>> = ({size = 50, ...rest}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 50 50" fill="none" {...rest}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25ZM26.1535 6.92791C25.7256 5.90366 24.2745 5.90365 23.8467 6.92791L18.8616 18.8616L6.92791 23.8467C5.90366 24.2745 5.90365 25.7256 6.92791 26.1535L18.8616 31.1385L23.8467 43.0722C24.2745 44.0965 25.7256 44.0965 26.1535 43.0722L31.1385 31.1385L43.0722 26.1535C44.0965 25.7256 44.0965 24.2745 43.0722 23.8467L31.1385 18.8616L26.1535 6.92791ZM25.0001 28.1251C26.726 28.1251 28.1251 26.726 28.1251 25.0001C28.1251 23.2742 26.726 21.8751 25.0001 21.8751C23.2742 21.8751 21.8751 23.2742 21.8751 25.0001C21.8751 26.726 23.2742 28.1251 25.0001 28.1251Z"
            fill="#007A87"
        />
    </svg>
)
